import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-oms-return-confirm',
  templateUrl: './oms-return-confirm.component.html',
  styleUrls: ['./oms-return-confirm.component.scss'],
})
export class OmsReturnConfirmComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { edpName: string }) {}
}
